import '../components/header-bar/header-bar';
import '../components/form/button-stateful';
import '../components/form/input-statefull';
import '../components/linkedin-auth';
import '../components/phone-input';

import moment from 'moment-timezone';

import { requestHandler, showMessage } from './tools';
import InputStatefull from '../components/form/input-statefull';
import PhoneInput from '../components/phone-input';
import { timezones } from '../../src/service/utils/location';
import { DEFAULT_MEMBER_TIMEZONE } from '../tools';

(function() {
    const signupbtn = document.querySelector('#auth-action-signup-btn') as any;

    const signup = () => {
        const signupForm = document.querySelector('#signup-auth-form') as HTMLFormElement;

        const email = (signupForm.querySelector('[type=email]') as InputStatefull)?.getValue();
        const password = (signupForm.querySelector('[type=password]') as InputStatefull)?.getValue();
        const phoneInput = (signupForm.querySelector('phone-input') as PhoneInput);
        const phoneNumber = phoneInput.phoneNumber;
        const timezone = (signupForm.querySelector('select[name="timezone"]') as HTMLSelectElement).value;

        if (!email || !email.trim()) {
            return showMessage('Email is required');
        } else if (!password) {
            return showMessage('Password is required');
        } else if (!phoneNumber) {
            return showMessage('Phone number is required');
        } else if (!timezone) {
            return showMessage('Timezone is required');
        }

        signupbtn.setAttribute('state', 'loading');
        requestHandler({ url: '/v2/auth/signup', method: 'POST', payload: JSON.stringify({ email: email.trim(), password, phoneNumber, timezone }) })
            .then(data => {
                const response = JSON.parse(data?.data);
                window.location.href = response?.redirectUrl;
                signupbtn.setAttribute('state', '');
            }).catch(e => {
                signupbtn.setAttribute('state', '');
                console.log('error', e);
            });

    };

    /**
     * Prefill the timezone input with the guessed timezone based on browser settings
     */
    const prefillTimezone = () => {
        const guessedTimezone = moment.tz.guess();
        const isExistingTimezone = timezones.find(tz => tz === guessedTimezone);
        const memberTimezone = isExistingTimezone ? guessedTimezone : DEFAULT_MEMBER_TIMEZONE;

        const timezoneInput = document.querySelector('select[name="timezone"]') as HTMLInputElement;
        timezoneInput.value = memberTimezone;
    };

    signupbtn.addEventListener('click', signup);
    prefillTimezone();
})();

